import { Component, OnInit } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { finalize } from 'rxjs/operators';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as _ from 'lodash';
import { MarcaService } from '../../../services/marca/marca.service';
import { Marca } from '../../../../model/class/Marca';
import { IMarca } from '../../../../model/interface/IMarca';

@Component({
  selector: 'app-marcas',
  templateUrl: './marcas.component.html',
  providers: [DragulaService]
})
export class MarcasComponent implements OnInit {

  loaders = {
    form: false
  };
  page = 1;
  pageSize = 18;

  todas: Marca[] = [];
  enPortada: Marca[] = [];

  constructor(
    private dragulaService: DragulaService,
    private toasts: ToastsManager,
    private marcaService: MarcaService,
  ) {
    dragulaService.setOptions('bag-marcas', {
    });

    dragulaService.dropModel.subscribe((value) => {
      this.emparejarOrden();
      this.onDropModel(value.slice(1));
    });
    dragulaService.removeModel.subscribe((value) => {
      this.onRemoveModel(value.slice(1));
    });
  }

  private onDropModel(args) {
    let [el, target, source] = args;
    // do something else
  }

  private onRemoveModel(args) {
    let [el, source] = args;
    // do something else
  }

  ngOnInit() {
    this.marcaService.all()
      .subscribe((resp) => {
        _.each(resp.data, (marca: IMarca) => {
          if (marca.esDestacada) {
            this.enPortada.push(new Marca(marca));
          } else {
            this.todas.push(new Marca(marca));
          }
        });

        this.enPortada = _.orderBy(this.enPortada, ['orden']);
        this.emparejarOrden();
      });
  }

  emparejarOrden() {
    _.each(this.enPortada, (marca: Marca, index) => {
      marca.orden = index + 1;

      if (index > 5) {
        this.todas.push(_.clone(marca));
      }
    });

    if (this.enPortada.length >= 6) {
      this.enPortada.splice(6, this.enPortada.length - 1);
    }

    // _.each(this.todas, (marca: Marca) => {
    //   marca.esDestacada = false;
    //   marca.modificado = true;
    // });
  }

  guardarCambios() {

    this.loaders.form = true;
    const modTodos = _.filter(this.todas, { 'esDestacada': true });

    const obsModificar = [];

    _.each(this.enPortada, (o: Marca) => {
      o.esDestacada = true;
      obsModificar.push(this.marcaService.edit(o.id, o.getFormDataOrden()));
    });

    _.each(modTodos, (o: Marca) => {
      o.esDestacada = false;
      obsModificar.push(this.marcaService.edit(o.id, o.getFormDataOrden()));
    });

    if (obsModificar.length > 0) {
      forkJoin(obsModificar)
        .pipe(
          finalize(() => {
            this.loaders.form = false;
          }))
        .subscribe(
          (res) => {
            this.toasts.success('Cambios guardados.');
          }, (error) => {
            this.toasts.error('Ah ocurrido un error al realizar los cambios.', 'Ups...');
            console.error(error);
          });
    } else {
      this.toasts.success('Cambios guardados.');
      this.loaders.form = false;
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/marcas/marcas.component.ts